module.exports = __webpack_public_path__ + "static/3-b4b2946159cdf270abccc1e97bc61ba3.png";